/**
 * Created by razial on 19.05.2025.
 */

const FakeSlot = function () {
    this.data = {};
};

FakeSlot.prototype.reset = function () {
    this.data = {};
};

FakeSlot.prototype.load = function (key) {
    return this.data[key];
};

FakeSlot.prototype.save = function (key, info) {
    this.data[key] = info;
};

FakeSlot.prototype.remove = function (key) {
    this.save(key, undefined);
};

FakeSlot.prototype.updateInfo = function () {

};

FakeSlot.prototype.getInfo = function () {

};